import { TextWatchfaceAttribute } from '@/services/shape/attributes/text-watchface';

export const useWatchfaceText = () => {
  const getDefaultTexts = (type: TextWatchfaceAttribute['textType']) => {
    if (type == 'dateWeek') {
      return [
        '今天是周日',
        '今天是周一',
        '今天是周二',
        '今天是周三',
        '今天是周四',
        '今天是周五',
        '今天是周六'
      ];
    }
    if (type == 'slogan') {
      return ['让生活更美好'];
    }
    return ['文本'];
  };

  return {
    getDefaultTexts
  };
};
